/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import Lesson from './Lesson.component';
import LockedCategoryModal from './LockedCategoryModal.component';
import { loaderArray } from '../../../../constant';
import TileLoader from '../../../shared/TileLoader';
import { gTag, modalOpen } from '../../../../helpers';
import { capitalize } from 'lodash';
import icons from '../../../../assets/img/icons.svg';
import whiteBookmarkIcon from '../../../../assets/img/White Bookmark Icon.png';

/**
 * @description This component render the list of lessons
 * @param {object} $lessons - {done, percent, seconds, when}
 * @param {boolean} $loading - true/false
 */
const Lessons = ({
  lessons,
  loading,
  setAttention,
  lockedCategories = [],
  interestedCategoryIds = [],
  saveLessonInterest,
}) => {
  const [show, showHide] = useState({});
  const [showAll, setShowAll] = useState(null);
  const [activeLockedCategory, setActiveLockedCategory] = useState(null);

  const openLockedModal = (cat) => {
    modalOpen(true);
    setActiveLockedCategory(cat);
  };

  const closeLockedModal = () => {
    setActiveLockedCategory(null);
  };

  const toggleShowClose = (lessons, status) =>
    Object.keys(lessons).reduce((prevValue, currValue) => {
      return {
        ...prevValue,
        [currValue]: status,
      };
    }, {});

  useEffect(() => {
    let show = localStorage.getItem('show') && JSON.parse(localStorage.getItem('show'));
    let showAll = localStorage.getItem('showAll') && JSON.parse(localStorage.getItem('showAll'));
    showAll && setShowAll(showAll);
    show && showHide(show);
    if (showAll) {
      showHide(toggleShowClose(lessons, true));
    } else if (show && !showAll) {
      showHide(show);
    } else if (!showAll) {
      showHide(toggleShowClose(lessons, false));
    }
  }, [lessons]);

  const handleShowHide = (item) => {
    let LessonTypes;
    show ? (LessonTypes = { ...show, [item]: !show[item] }) : (LessonTypes = { [item]: !show[item] });
    showHide(LessonTypes);
    localStorage.setItem('show', JSON.stringify(LessonTypes));
  };

  const showHideAll = () => {
    setShowAll(!showAll);
    localStorage.setItem('showAll', JSON.stringify(!showAll));
    showHide(toggleShowClose(lessons, !showAll));
    !!showAll && localStorage.removeItem('show');
  };
  return (
    <div>
      <header className="intro">
        {window.location.hash === '#/insights/blog' ? (
          <p>These are your company's blog lesson shenanigans you should watch</p>
        ) : (
          <p>
            These short video Lessons answer critical questions about how to develop business. Watch them in sequence or
            skip ahead to topics of interests.
          </p>
        )}
        {/* <p>
          These short video Lessons answer critical questions about how to
          develop business. Watch them in sequence or skip ahead to topics of
          interest.
        </p> */}
      </header>
      <ol className="ai-dashboard lesson-container" id="trainer-list">
        <li className="break collapsible" onClick={showHideAll}>
          <h2 className="open-close-all">
            <label>
              <span>{showAll ? 'Close All' : 'Open All'}</span>
              <span className="caret-wrapper">
                <span className="caret" />
              </span>
            </label>
          </h2>
        </li>
        {loading
          ? loaderArray.map((i) => (
              <li key={i}>
                <TileLoader />
              </li>
            ))
          : Object.keys(lessons).map((item, index) => {
              const description = lessons[item][0].focus_description || '';
              return (
                <React.Fragment key={index}>
                  <li
                    className="break collapsible"
                    onClick={() => {
                      handleShowHide(item);
                      gTag(`Lesson Category: ${capitalize(item)}`, !show[item] ? 'Expanded' : 'Collapsed');
                    }}
                  >
                    <h2>
                      <label>
                        <span>{item}</span>
                        <span className="caret-wrapper">
                          <span className="caret" />
                        </span>
                      </label>
                    </h2>
                    <div className="description">{description}</div>
                  </li>
                  {show[item] &&
                    lessons[item].map((lesson) => <Lesson key={lesson.id} {...lesson} setAttention={setAttention} />)}
                </React.Fragment>
              );
            })}
        {lockedCategories.map((cat) => (
          <li key={cat.id} className="break collapsible" style={{ opacity: 0.5 }} onClick={() => openLockedModal(cat)}>
            <h2>
              <label>
                <span>
                  <svg className="icon" style={{ verticalAlign: 'middle', marginRight: '6px' }}>
                    <use xlinkHref={`${icons}#license`} />
                  </svg>
                  {cat.name}
                </span>
                {interestedCategoryIds.includes(cat.id) && (
                  <img src={whiteBookmarkIcon} alt="" className="locked-category-bookmark" />
                )}
              </label>
            </h2>
            <div className="description">{cat.description}</div>
          </li>
        ))}
      </ol>
      {activeLockedCategory && (
        <LockedCategoryModal
          category={activeLockedCategory}
          isInterested={interestedCategoryIds.includes(activeLockedCategory.id)}
          onInterest={saveLessonInterest}
          onClose={closeLockedModal}
        />
      )}
    </div>
  );
};

export default Lessons;
